export default "__VITE_ASSET__C4FjrcJ4__"